import { render, staticRenderFns } from "./fpppa.vue?vue&type=template&id=c64998a0&scoped=true&"
import script from "./fpppa.vue?vue&type=script&lang=js&"
export * from "./fpppa.vue?vue&type=script&lang=js&"
import style0 from "./fpppa.vue?vue&type=style&index=0&id=c64998a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64998a0",
  null
  
)

export default component.exports